import { z } from 'zod';

export const technologyContributorSchema = z
  .object({
    contributionsEndDate: z.string().nullable(),
    contributionsStartDate: z.string().nullable(),
    userId: z
      .string({ required_error: 'Please select a team member' })
      .min(1, 'Please select a team member')
      .uuid('Please select a valid team member'),
  })
  .superRefine((data, ctx) => {
    if (data.contributionsEndDate && !data.contributionsStartDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Start date is required when an end date is provided',
        path: ['contributionsStartDate'],
      });
      return;
    }

    if (!data.contributionsEndDate || !data.contributionsStartDate) {
      return;
    }

    if (data.contributionsEndDate < data.contributionsStartDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'End date cannot be earlier than start date',
        path: ['contributionsEndDate'],
      });
    }
  });

export type TechnologyContributorFormData = z.infer<typeof technologyContributorSchema>;
